function initMainBlog() {
  const modalOpenButton = document.querySelector('.main-blog__filters-trigger');
  const modalCloseButton = document.querySelector('.facets-blog__close');
  const modalElement = document.querySelector('.main-blog__dialog');

  initEvents(modalOpenButton, modalCloseButton, modalElement);
}

function initEvents(modalOpenButton, modalCloseButton, modalElement) {
  modalOpenButton.addEventListener('click', (e) => {
    e.preventDefault();
    openModal(modalElement);
  });

  modalCloseButton.addEventListener('click', (e) => {
    e.preventDefault();
    closeModal(modalElement);
  });
}

function openModal(modalElement) {
  modalElement.showModal()
}

function closeModal(modalElement) {
  modalElement.close();
}

window.onload = initMainBlog();
